import React from 'react';


type Props = {
    mt?: number,
    mb?: number,
    pt?: number,
    pb?: number,
    color?: string,
    height?: 1 | 2 | 3
}

const Hr: React.FC<Props> = ({ 
    mt = 0.75, 
    mb = 0.75,
    pt = 0,
    pb = 0,
    color = 'var(--bs-dark)',
    height = 1
}) => {


    return (
        <div style={{
            marginTop: `${mt}rem`,
            marginBottom: `${mb}rem`,
            paddingTop: `${pt}rem`,
            paddingBottom: `${pb}rem`,
            border: 0,
            height: `${height}px`,
            backgroundImage: `linear-gradient(to right, rgba(0, 0, 0, 0), ${color}, rgba(0, 0, 0, 0))`
        }}></div>
    );
}

export default Hr;